import { ChangeDetectionStrategy, Component, inject, Input, TemplateRef } from '@angular/core';
import { CreditBreakdownNode } from '@app/services/api/api.types';
import { CommonDataService } from '@app/services/common-data/common-data.service';
import { PopupsService } from '@voyagu/portal-design-system';

@Component({
  selector: 'wallet-balance',
  templateUrl: './wallet-balance.component.html',
  styleUrl: './wallet-balance.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WalletBalanceComponent {
  popupsService = inject(PopupsService);
  commonDataService = inject(CommonDataService);

  @Input() clientBalanceAmount: number;
  @Input() creditBreakdown: CreditBreakdownNode[] = [];

  showModal(modalTemplate: TemplateRef<unknown>) {
    this.popupsService.showModal(modalTemplate);
  }

  hideModal() {
    this.popupsService.hideLast();
  }
}
